export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12118.d6c81c72.jpg";